/**
 * App Configuration
 * Centralized configuration for app URLs and settings
 */

/**
 * Get the base URL for the app
 * Uses custom domain in production, falls back to current origin in development
 */
export const getBaseUrl = (): string => {
  // Check if we're in production (on Vercel or custom domain)
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  
  // If already on tensionlabs.net, use it
  if (hostname.includes('tensionlabs.net')) {
    return 'https://tensionlabs.net';
  }
  
  // If on Vercel preview deployment or Figma proxy, use production domain
  if (hostname.includes('vercel.app') || hostname.includes('figma.site') || hostname.includes('makeproxy')) {
    return 'https://tensionlabs.net';
  }
  
  // For local development, use localhost
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return window.location.origin;
  }
  
  // Default to production domain
  return 'https://tensionlabs.net';
};

/**
 * Get referral link with code
 */
export const getReferralLink = (referralCode: string): string => {
  return `${getBaseUrl()}/auth?ref=${referralCode}`;
};

/**
 * Get public landing link (legacy name kept for compatibility)
 */
export const getBetaLandingLink = (): string => {
  return `${getBaseUrl()}/early-access`;
};

/**
 * Get waitlist referral link
 */
export const getWaitlistReferralLink = (referralCode: string): string => {
  return `${getBaseUrl()}/early-access?waitlist_ref=${referralCode}`;
};

/**
 * Get affiliate partner link
 */
export const getAffiliateLink = (affiliateCode: string): string => {
  return `${getBaseUrl()}/early-access?partner=${affiliateCode}`;
};

/**
 * Get beta activation link
 */
export const getBetaActivationLink = (betaKey: string): string => {
  return `${getBaseUrl()}/auth?beta_key=${betaKey}`;
};

/**
 * App configuration constants
 */
export const APP_CONFIG = {
  productionUrl: 'https://tensionlabs.net',
  appName: 'TENSION',
  supportEmail: 'hello@tensionlabs.net',
  noReplyEmail: 'noreply@tensionlabs.net',
  socialProfiles: {
    x: import.meta.env.VITE_SOCIAL_X_URL || '',
    facebook: import.meta.env.VITE_SOCIAL_FACEBOOK_URL || '',
    linkedin: import.meta.env.VITE_SOCIAL_LINKEDIN_URL || '',
    instagram: import.meta.env.VITE_SOCIAL_INSTAGRAM_URL || '',
  },
} as const;
